/**
 * Created by tomers on 5/31/2015.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var ErrorCodes = require("codeTables/errorCodes.json");
    var CONST = require("const");

    var SelectableCollectionDecorator = require("decorators/SelectableCollectionDecorator");
    var OrganizeCollectionDecorator = require ("decorators/organizeCollectionDecorator/OrganizeCollectionDecorator");

    var SkillListLayout = require("user-management-views/skills/SkillListLayout");
    var SkillsGridView = require("user-management-views/skills/SkillsGridView");
    var SkillsGridModel = require("user-management-models/SkillsGridModel");
    var SkillListFilters = require("user-management-filters/SkillListFilters");
    var SecureUtilities = require("infra-util/SecureUtilities");
    var UserManagementUtilities = require("user-management-utils/UserManagementUtilities");
    var SkillListComparators = require("user-management-comparators/SkillListComparators");

    var DEFAULT_COMPARATOR = "name";
    var DEFAULT_ORDERBY = "asc";
    var PAGE_SIZE = 25;

    var SkillListController = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        SkillListController = Marionette.Controller.extend({
            dataInitialized: false,
            viewInitialized: false,
            initialize: function (options) {
                this._initialize(options);
            },

            getView: function (options) {
                return this._getView(options);
            },
            onNavigateOut: function(){
                this._onNavigateOut();
            },



            _initialize: function (options) {
                LEUserManagement.logger.debug("_initialize", "SkillListController:_initialize");
                this.channel = LEUserManagement.media.channel(LEUserManagement.channels.SKILL_LIST);
                this.skillsGridModel = new SkillsGridModel();
                this._bindEventsChannel();
            },

            _bindEventsChannel: function() {
                LEUserManagement.logger.debug("_bindEventsChannel", "SkillListController:_bindEventsChannel");
                this.listenTo(this.channel, "paging:change", this._onPagingChange);
                this.listenTo(this.channel, "row:selector:click", this._onRowSelectorClick);
                this.listenTo(this.channel, "row:click", this._onRowClick);
                this.listenTo(this.channel, "actionMenu:select", this._onActionMenuSelect);
            },

            _getView: function(options) {
                LEUserManagement.logger.debug("_getView", "SkillListController:_getView");
                this._unbindEventsDataAndViews();
                this._initData(options);
                this._initViews();
                this._bindEventsDataAndViews();
                return this.skillListLayout;
            },

            _initData: function(options) {
                LEUserManagement.logger.debug("_initData", "SkillListController:_initData");
                if (!this.dataInitialized) {
                    var skillsCollection = LEUserManagement.getDataManager().getSkillsCollection();
                    skillsCollection = SelectableCollectionDecorator.decorate(skillsCollection);
                    this.skillsOrganizedCollection = OrganizeCollectionDecorator.decorate(skillsCollection, {
                        comparator: DEFAULT_COMPARATOR,
                        orderBy: DEFAULT_ORDERBY,
                        pageSize: PAGE_SIZE,
                        lazy: true
                    });

                    this.skillsOrganizedCollection.reset(); //start the table collection empty until the first organize call, do not worry original is still full.
                    this.dataInitialized = true;
                }

            },

            _initViews: function() {
                LEUserManagement.logger.debug("_initViews", "SkillListController:_initViews");
                if (!this.viewInitialized) {
                    var acUsersAccount = LE.siteSettings.accountSettings.isAcUser();
                    var exportAcUsersData = UserManagementUtilities.hasExportAcUsersData();
                    this.skillListLayout = new SkillListLayout({
                        collection:this.skillsOrganizedCollection,
                        displayAcUsersExport: (exportAcUsersData && acUsersAccount)
                    });
                    this.skillsGridView = new SkillsGridView({
                        collection:this.skillsOrganizedCollection,
                        model: this.skillsGridModel,
                        filters: SkillListFilters,
                        comparators: SkillListComparators
                    });
                    this.viewInitialized = true;
                }
            },

            _bindEventsDataAndViews: function() {
                LEUserManagement.logger.debug("_bindEventsDataAndViews", "SkillListController:_bindEventsDataAndViews");
                this.listenTo(this.skillListLayout, "render", this._onLayoutRender);
                this.listenTo(this.skillListLayout, "show", this._onLayoutShown);
                this.listenTo(this.skillListLayout, "close", this._onLayoutClose);

                this.listenTo(this.skillsOrganizedCollection ,"reset", this._onCollectionReset);
                this.skillsOrganizedCollection.bindToOriginalCollectionEvents();
            },
            //happens once
            _onLayoutRender: function() {
                LEUserManagement.logger.debug("_onLayoutRender", "SkillListController:_onLayoutRender");
                this.skillListLayout.gridRegion.show(this.skillsGridView);
            },
            //happens every time
            _onLayoutShown: function() {
                LEUserManagement.logger.debug("_onLayoutShown", "SkillListController:_onLayoutShown");
                this.skillsOrganizedCollection.organize({filterModel:this.skillsGridModel});
            },

            _onCollectionReset: function(collection, options) {
                LEUserManagement.logger.debug("_onCollectionReset", "SkillListController:_onCollectionReset");
                this._handleActionMenu();
            },

            _onPagingChange: function(currentPageNumber) {
                LEUserManagement.logger.debug("_onPagingChange page: " +currentPageNumber, "SkillListController:_onPagingChange");
                this.skillsOrganizedCollection.organize({currentPage:currentPageNumber});
            },

            _onRowSelectorClick: function(options) {
                LEUserManagement.logger.debug("_onRowSelectorClick", "SkillListController:_onRowSelectorClick");
                var itemModel = options.itemModel;
                var isChecked = options.isChecked;

                if (isChecked) {
                    var currentSelectedModel = this.skillsOrganizedCollection.getSelectedModel();
                    if (!_.isEmpty(currentSelectedModel)) {
                        currentSelectedModel.trigger("model:selection:change", false);
                    }
                    this.skillsOrganizedCollection.addToSelection(itemModel, {exclusively:true});
                    itemModel.trigger("model:selection:change", true);
                }
                else {
                    this.skillsOrganizedCollection.deselectModel(itemModel);
                    itemModel.trigger("model:selection:change", false);
                }

                this._handleActionMenu();
            },

            _onRowClick: function(skillModel) {
                LEUserManagement.logger.debug("_onRowClick for id" + skillModel.id, "SkillListController:_onRowClick");
                this._navigateToSkill(skillModel.id);
            },

            _handleActionMenu: function() {
                LEUserManagement.logger.debug("_handleActionMenu", "SkillListController:_handleActionMenu");
                var selectedModel = this.skillsOrganizedCollection.getSelectedModel();
                var isAnyModelSelected = (!_.isEmpty(selectedModel));
                this.channel.trigger("actionMenu:set", {id:SkillListLayout.ACTION_MENU_ITEMS.EDIT, enabled:isAnyModelSelected});
                this.channel.trigger("actionMenu:set", {id:SkillListLayout.ACTION_MENU_ITEMS.DELETE, enabled:isAnyModelSelected});
            },

            _onActionMenuSelect: function(selectedItemId) {
                LEUserManagement.logger.debug("_onActionMenuSelect", "SkillListController:_onActionMenuSelect");
                switch (selectedItemId) {
                    case SkillListLayout.ACTION_MENU_ITEMS.ADD:
                        this._onAddSelected();
                        break;
                    case SkillListLayout.ACTION_MENU_ITEMS.EDIT:
                        this._onEditSelected();
                        break;
                    case SkillListLayout.ACTION_MENU_ITEMS.DELETE:
                        this._onDeleteSelected();
                        break;
                    case SkillListLayout.ACTION_MENU_ITEMS.EXPORT:
                        this._exportAllList();
                        break;
                }
            },

            _onAddSelected: function() {
                LEUserManagement.logger.debug("_onAddSelected", "SkillListController:_onAddSelected");
                this._navigateToSkill(CONST.ROUTING.NEW_ITEM_ID);
            },

            _onEditSelected: function() {
                LEUserManagement.logger.debug("_onEditSelected", "SkillListController:_onEditSelected");
                var selectedModel = this.skillsOrganizedCollection.getSelectedModel();
                if (!_.isEmpty(selectedModel)) {
                    this._navigateToSkill(selectedModel.id);
                }
            },

            _onDeleteSelected: function() {
                LEUserManagement.logger.debug("_onDeleteSelected", "SkillListController:_onDeleteSelected");
                var selectedModel = this.skillsOrganizedCollection.getSelectedModel();
                if (!_.isEmpty(selectedModel)) {

                    var message = LE.translator.translate({
                        key: "LEUserManagement.skillList.delete.newConfirm.text",
                        args: [{key: SecureUtilities.escapeForHtmlContent(selectedModel.getName()), isTranslate:false}]
                    });

                    LEUserManagement.notifier.showConfirm({
                        title: LE.translator.translate("LEFramework.global.captions.are.you.sure"),
                        content: message,
                        objectAction: {
                            text: LE.translator.translate("LEFramework.global.captions.delete"),
                            callback: _.bind(this._onDeleteConfirmed, this)
                        }
                    });
                }
            },

            _onDeleteConfirmed: function() {
                LEUserManagement.logger.debug("_onDeleteConfirmed", "SkillListController:_onDeleteConfirmed");
                var selectedModel = this.skillsOrganizedCollection.getSelectedModel();
                if (!_.isEmpty(selectedModel)) {

                    LEUserManagement.showLoader();
                    selectedModel.destroy({
                        success: _.bind(this._onDeleteSuccess, this),
                        error: _.bind(this._onDeleteError, this),
                        wait: true
                    });
                }
            },

            _onDeleteSuccess: function(model, resp, options) {
                LEUserManagement.logger.debug("_onDeleteSuccess", "SkillListController:_onDeleteSuccess");
                LEUserManagement.closeLoader();
                this.skillsOrganizedCollection.clearSelection();
            },

            _onDeleteError: function(model, resp, options) {
                LEUserManagement.logger.debug("_onDeleteError", "SkillListController:_onDeleteError",resp);
                LEUserManagement.closeLoader();
                var errorMessage = options.errorMessage?options.errorMessage:LE.translator.translate("LEFramework.something.went.wrong");
                LEUserManagement.notifier.showConfirm({
                    title: LE.translator.translate("LEUserManagement.skillList.delete.error.title"),
                    content: errorMessage,
                    objectAction: {
                        text: LE.translator.translate("LEFramework.global.captions.ok"),
                        callback: function(){}
                    },
                    removeAditionalButton: true
                });
            },

            _onLayoutClose: function() {
                LEUserManagement.logger.debug("_onLayoutClose", "SkillListController:_onLayoutClose");
                this._unbindEventsDataAndViews();
            },

            _unbindEventsDataAndViews: function() {
                LEUserManagement.logger.debug("_unbindEventsDataAndViews", "SkillListController:_unbindEventsDataAndViews");
                if (this.skillListLayout) {
                    this.stopListening(this.skillListLayout);
                }
                if (this.skillsOrganizedCollection) {
                    this.stopListening(this.skillsOrganizedCollection);
                    this.skillsOrganizedCollection.unBindFromOriginalCollectionEvents();
                }

            },

            _onNavigateOut: function(){
                this._unbindEventsDataAndViews();
            },

            _navigateToSkill: function(skillId) {
                LEUserManagement.logger.debug("_navigateToSkill", "SkillListController:_navigateToSkill");
                LEUserManagement.router.navigate("skills/"+skillId);
            },

            _exportAllList: function() {
                LEUserManagement.logger.debug("_exportAllList", "SkillListController:_exportAllList");
                UserManagementUtilities.exportAllList();
            }
        });
    }

    LE.module("LEUserManagement", moduleDefinition);

    return SkillListController;
});

